type Props = {
    isActive: boolean
    onClick: any
}

const GridViewIcon = ({ isActive, onClick }: Props) => {
    const height = '24'
    const width = '24'

    return (
        <svg
            style={{ cursor: 'pointer' }}
            onClick={onClick}
            width={`${width}`}
            height={`${height}`}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.9">
                <rect
                    x="12.7354"
                    width="11.2646"
                    height="11.2653"
                    fill={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                />
                <rect
                    x="12.7351"
                    y="12.7343"
                    width="11.2646"
                    height="11.2653"
                    fill={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                />
                <rect
                    width="11.2646"
                    height="11.2653"
                    fill={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                />
                <rect
                    x="0.000244141"
                    y="12.7347"
                    width="11.2646"
                    height="11.2653"
                    fill={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                />
            </g>
        </svg>
    )
}

export default GridViewIcon
